// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_quote_text = /** @type {(inputs: {}) => string} */ () => {
	return `From a medical perspective, I recommend the kybun shoe especially for patients who have postural faults or knee problems.`
};

const el_tech_quote_text = /** @type {(inputs: {}) => string} */ () => {
	return `Από ιατρική άποψη, συνιστώ το παπούτσι kybun ιδιαίτερα σε ασθενείς με προβλήματα στάσης ή στα γόνατα.`
};

const ru_tech_quote_text = /** @type {(inputs: {}) => string} */ () => {
	return `С медицинской точки зрения я рекомендую обувь kybun, особенно пациентам с нарушениями осанки или проблемами с коленями.`
};

const he_tech_quote_text = /** @type {(inputs: {}) => string} */ () => {
	return `מנקודת מבט רפואית, אני ממליץ על נעלי kybun במיוחד למטופלים עם בעיות יציבה או בעיות ברכיים.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_quote_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_quote_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_quote_text", locale)
	if (locale === "en") return en_tech_quote_text(inputs)
	if (locale === "el") return el_tech_quote_text(inputs)
	if (locale === "ru") return ru_tech_quote_text(inputs)
	if (locale === "he") return he_tech_quote_text(inputs)
	return "tech_quote_text"
};